import o from "./ghl-ui.es1289.js";
import r from "./ghl-ui.es1290.js";
var m = r(function(a, e, t) {
  return e = e.toLowerCase(), a + (t ? o(e) : e);
});
const n = m;
export {
  n as default
};
